"use client"

import { Card, CardContent, CardFooter } from "@/components/ui/card"
import { Resources } from "../categoryPanel"
import { ResourceLink } from "./ResourceLink"
import { usePathname } from "next/navigation"
import Link from "next/link"
import { FaTag } from "react-icons/fa6"
import OptimizedImage from "@/components/ui/Image/OptimizedImage"

export function ResourceIndustryCard({ item, href, ariaLabel }: { item: Resources; href: string; ariaLabel: string }) {
   const pathname = usePathname()
   const segments = pathname.split("/")
   const currentResourceType = segments[2] || "library"
   const activeCategory = item.category?.name ?? "Uncategorized"
   const categoryLink = `/resources/${currentResourceType}/`

   return (
      <Card className="group col-span-full flex h-full flex-col overflow-hidden rounded-2xl border border-gray-100 bg-white p-0 shadow-sm sm:col-span-1">
         <Link aria-label={ariaLabel} href={href}>
            <div className="relative flex h-64 w-full items-center justify-center overflow-hidden bg-gray-100">
               <OptimizedImage
                  src={item.image}
                  alt={item.title}
                  width={400}
                  height={300}
                  sizes="(min-width: 85rem) 676px, (min-width: 1024px) 50vw, 100vw"
                  className="h-full w-full object-cover object-center"
               />

               <Link
                  aria-label={`View more resources in ${activeCategory}`}
                  href={categoryLink}
                  className="absolute right-4 top-4 flex items-center gap-2 rounded-md border border-gray-100 bg-[#FAF8F7] px-3 py-2 shadow-sm transition-colors hover:bg-custom-primary/20"
               >
                  <FaTag className="h-4 w-4 text-[#EF5929]" aria-hidden="true" />
                  <span className="text-custom-xs-medium uppercase text-[#EF5929]">{activeCategory}</span>
               </Link>
            </div>

            <CardContent className="flex-1 space-y-5 p-6">
               <h2 className="line-clamp-2 h-[4.5rem] font-lora text-custom-26-bold">{item.title}</h2>

               {item.description && (
                  <p className="line-clamp-3 min-h-[4rem] text-custom-base-medium text-[#333333]">{item.description}</p>
               )}
            </CardContent>

            <CardFooter className="p-6 pt-2">
               <ResourceLink href={href} ariaLabel={ariaLabel} />
            </CardFooter>
         </Link>
      </Card>
   )
}
